<template>
  <MainLayout page-name="hangar-usages-data">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="import" @click="clickImport">新規取込</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true"/>
        <ActionType v-model="simpleSearchFormModel.action_type" :searchCond="true" :initialize="true" mode="hangarUsage" />
        <CustomerCode v-model="simpleSearchFormModel.operator_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" label="運航者" prop="operator_code" />
        <RegistrationSymbol v-model="simpleSearchFormModel.registration_symbol" :searchCond="true" :autocomplete-list="registrationSymbolSet" :initialize="true" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :multiSelect=false
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'hangar_usage_action_time', order: 'ascending' }"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <ActionTypeNameColumn :sortable="true" label="入出庫区分" prop="action_type" />
        <CustomerCodeColumn :sortable="true" label="運航者" prop="operator_code" />
        <RegistrationSymbolColumn :sortable="true" />
        <DateTimeColumn :sortable="true" label="入出庫日時" prop="hangar_usage_action_time" />
        <BlankColumn /> -->
        <ActionTypeNameColumn label="入出庫区分" prop="action_type" />
        <CustomerCodeColumn label="運航者" prop="operator_code" />
        <RegistrationSymbolColumn />
        <DateTimeColumn label="入出庫日時" prop="hangar_usage_action_time" />
        <BlankColumn />
      </template>
    </Table>
    <HangarUsagesDataImportDialog
      :visible.sync="importDialogVisible"
      @refresh="refreshSearch"
    />
    <HangarUsagesDataDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      @search="detailSearch"
    />
    <HangarUsagesDataEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
// import BillingYmColumn from '@/components/molecules/table/BillingYmColumn.vue'
import ActionTypeNameColumn from '@/components/molecules/table/ActionTypeNameColumn.vue'
import CustomerCodeColumn from '@/components/molecules/table/CustomerCodeColumn.vue'
import RegistrationSymbolColumn from '@/components/molecules/table/RegistrationSymbolColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import HangarUsagesDataImportDialog from '@/components/pages/data/hangarUsagesData/HangarUsagesDataImportDialog.vue'
import HangarUsagesDataDetailSearchDialog from '@/components/pages/data/hangarUsagesData/HangarUsagesDataDetailSearchDialog.vue'
import HangarUsagesDataEditDialog from '@/components/pages/data/hangarUsagesData/HangarUsagesDataEditDialog.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    ActionType,
    CustomerCode,
    RegistrationSymbol,
    SimpleSearch,
    Table,
    // BillingYmColumn,
    ActionTypeNameColumn,
    CustomerCodeColumn,
    RegistrationSymbolColumn,
    DateTimeColumn,
    BlankColumn,
    HangarUsagesDataImportDialog,
    HangarUsagesDataDetailSearchDialog,
    HangarUsagesDataEditDialog
  },
  mixins: [
    CustomerAutocompleteLoader,
    RegistrationSymbolAutocompleteLoader
  ],
  data () {
    return {
      title: '格納庫使用データ',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        action_type: '',
        operator_code: '',
        registration_symbol: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('hangarUsagesDataSearchCond')
    this.loadRegistrationSymbol()
    this.loadCustomer()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('hangarUsagesDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('hangarUsagesDataSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('hangarUsagesDataSearchCond'))
      this.$axios
        .get('/search-hangar-usages-data', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('hangarUsagesDataSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('hangarUsagesDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.update_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/hangar-usages-data', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
